import axios from 'axios';
import type { BibleChapterResponse, Reading, Verse } from './types';

export const bibleApiClient = axios.create({
  baseURL: 'https://bible.helloao.org/api/rus_syn',
});

export const READINGS: Reading[] = [
  {
    book: 'PSA',
    chapter: 22,
    verse: 1,
    fallback: {
      reference: 'Псалом 22:1',
      text: 'Господь — Пастырь мой; я ни в чём не буду нуждаться.',
    },
  },
  {
    book: 'PSA',
    chapter: 90,
    verse: 1,
    fallback: {
      reference: 'Псалом 90:1',
      text: 'Живущий под кровом Всевышнего под сенью Всемогущего покоится.',
    },
  },
  {
    book: 'JHN',
    chapter: 3,
    verse: 16,
    fallback: {
      reference: 'Евангелие от Иоанна 3:16',
      text: 'Ибо так возлюбил Бог мир, что отдал Сына Своего Единородного, дабы всякий верующий в Него не погиб, но имел жизнь вечную.',
    },
  },
  {
    book: 'PHP',
    chapter: 4,
    verse: 13,
    fallback: {
      reference: 'Послание к Филиппийцам 4:13',
      text: 'Всё могу в укрепляющем меня Иисусе Христе.',
    },
  },
  {
    book: 'ROM',
    chapter: 8,
    verse: 28,
    fallback: {
      reference: 'Послание к Римлянам 8:28',
      text: 'Притом знаем, что любящим Бога, призванным по Его изволению, всё содействует ко благу.',
    },
  },
  {
    book: 'MAT',
    chapter: 11,
    verse: 28,
    fallback: {
      reference: 'Евангелие от Матфея 11:28',
      text: 'Придите ко Мне все труждающиеся и обременённые, и Я успокою вас.',
    },
  },
  {
    book: 'ISA',
    chapter: 40,
    verse: 31,
    fallback: {
      reference: 'Книга пророка Исаии 40:31',
      text: 'А надеющиеся на Господа обновятся в силе: поднимут крылья, как орлы, потекут — и не устанут, пойдут — и не утомятся.',
    },
  },
  {
    book: 'PRO',
    chapter: 3,
    verse: 5,
    fallback: {
      reference: 'Книга Притчей 3:5',
      text: 'Надейся на Господа всем сердцем твоим, и не полагайся на разум твой.',
    },
  },
];

export function extractText(content: unknown): string {
  if (typeof content === 'string') {
    return content;
  }

  if (Array.isArray(content)) {
    return content.map(extractText).filter(Boolean).join(' ');
  }

  if (content && typeof content === 'object' && 'text' in content) {
    const value = (content as { text: unknown }).text;

    return typeof value === 'string' ? value : '';
  }

  return '';
}

export async function fetchReading(reading: Reading): Promise<Verse> {
  const { data } = await bibleApiClient.get<BibleChapterResponse>(
    `/${reading.book}/${reading.chapter}.json`
  );
  const verseItem = data.chapter?.content?.find(
    (item) => item.type === 'verse' && item.number === reading.verse
  );
  const text = extractText(verseItem?.content).trim();
  const bookName = data.book?.name;
  const chapterNumber = data.chapter?.number;

  if (!text || !bookName || !chapterNumber) {
    throw new Error('Bible API response does not contain verse text');
  }

  return {
    reference: `${bookName} ${chapterNumber}:${reading.verse}`,
    text,
  };
}
